import React from 'react';
import { Button, Card, CardContent, Grid, Tooltip, Typography } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import { Visibility } from '@mui/icons-material';

/**
 * Pantalla de Documentos de Inscripción.
 *
 * Muestra los documentos asociados al registro de medios de comunicación:
 *   - Carátula del expediente (generada al enviar/crear la solicitud)
 *   - Documento de Pleno (generada al aprobar al estado 4)
 *
 * Endpoints del backend:
 *   GET /formularioDeRegistroDeMediosDeComunicacion/obtenerCaratula/{id}
 *   GET /formularioDeRegistroDeMediosDeComunicacion/obtenerJustificacionPleno/{id}
 */
const DocumentosDeInscripcion = ({ datosGeneralesDeSolicitud, obtenerDocumentoAdjunto }) => {
  const classes = styles();

  const estado = Number(datosGeneralesDeSolicitud?.idEstadoDeSolicitudEmpresa || 0);
  const tieneCaratula = Boolean(datosGeneralesDeSolicitud?.id); //Se muestra la carátula generada al crear la solicitud
  const tieneDocDePleno = estado === 4;

  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container justifyContent="center" alignItems="center" spacing={2}>

          {/* Encabezado */}
          <Grid item xs={12}>
            <TituloConIcono
              title="Carátula de Solicitud de Inscripción"
              mostrarTiempo={false}
              mostrarBotones={false}
              showIcon={false}
            />
          </Grid>

          {/* Descripción informativa */}
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              A continuación puede visualizar la carátula de solicitud de inscripción
              correspondiente al registro seleccionado.
            </Typography>
          </Grid>

          {/* Botón VER CARÁTULA */}
          <Grid item xs={12} md={12} mt={2}>
            <Tooltip title={!tieneCaratula ? 'La carátula aún no ha sido generada' : ''} arrow>
              <span style={{ display: 'block' }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth
                  disabled={!tieneCaratula}
                  onClick={() =>
                    obtenerDocumentoAdjunto(
                      { id: 5, nombre: 'documentosDeInscripcion' },
                      'caratula'
                    )
                  }
                >
                  <Visibility sx={{ mr: 1 }} />
                  Ver Carátula
                </Button>
              </span>
            </Tooltip>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DocumentosDeInscripcion;
